import {XwaysHoarder2} from "../XwaysHoarder2";
import {MatrixUtils} from "../utils/MatrixUtils";
import {XwaysHoarder2Statics} from "../XwaysHoarder2Statics";

export class XwaysHoarder2SymbolHeightCalculator {
    public static symbolVisualHeightCalculator(): number[][] {
        const roundEndHeights: number[][] = [[200, 200, 200], [200, 200, 200], [200, 200, 200], [200, 200, 200], [200, 200, 200], [200, 200, 200]];
        const updatedReels: string[][] = MatrixUtils.cloneMatrix(XwaysHoarder2.model.reels);
        XwaysHoarder2.model.firstXWPerReelPos.forEach((pos, index) => {
            if (XwaysHoarder2.model.xwaysCountPerReel[pos[0]] === 1) {//check for normal expansion
                if (!updatedReels[pos[0]].includes("SC") && !updatedReels[pos[0]].includes("SSC") && !updatedReels[pos[0]].includes("XS") && !updatedReels[pos[0]].includes("XN")) {
                    const checkNoXFeatures = updatedReels[pos[0]].filter((item) => item.includes("X"));
                    if (checkNoXFeatures.length < 3) {
                        if (checkNoXFeatures.length === 1) {
                            if (pos[1] === 0) {//xWays is on first row
                                if (XwaysHoarder2Statics.payingSymbols.includes(updatedReels[pos[0]][1])) {
                                    roundEndHeights[pos[0]][1] = 100;
                                }
                                if (XwaysHoarder2Statics.payingSymbols.includes(updatedReels[pos[0]][2])) {
                                    roundEndHeights[pos[0]][2] = 100;
                                }

                            } else if (pos[1] === 1) { //xWays is on second row
                                if (XwaysHoarder2Statics.payingSymbols.includes(updatedReels[pos[0]][0])) {
                                    roundEndHeights[pos[0]][0] = 100;
                                }
                                if (XwaysHoarder2Statics.payingSymbols.includes(updatedReels[pos[0]][2])) {
                                    roundEndHeights[pos[0]][2] = 100;
                                }
                            } else if (pos[1] === 2) {    //xWays is on third row
                                if (XwaysHoarder2Statics.payingSymbols.includes(updatedReels[pos[0]][0])) {
                                    roundEndHeights[pos[0]][0] = 100;
                                }
                                if (XwaysHoarder2Statics.payingSymbols.includes(updatedReels[pos[0]][1])) {
                                    roundEndHeights[pos[0]][1] = 100;
                                }
                            }

                            roundEndHeights[pos[0]][pos[1]] = 400;

                        } else if (checkNoXFeatures.length === 2) {
                            let toResizeXway = false;
                            if (pos[1] === 0 && XwaysHoarder2Statics.payingSymbols.includes(updatedReels[pos[0]][1])) {//xWays is on first row
                                roundEndHeights[pos[0]][1] = 100;
                                toResizeXway = true;
                            } else if (pos[1] === 1) {
                                toResizeXway = true;
                                if (XwaysHoarder2Statics.payingSymbols.includes(updatedReels[pos[0]][0])) {
                                    roundEndHeights[pos[0]][0] = 100;
                                } else if (XwaysHoarder2Statics.payingSymbols.includes(updatedReels[pos[0]][2])) {
                                    roundEndHeights[pos[0]][2] = 100;
                                }
                            } else if (pos[2] === 2 && XwaysHoarder2Statics.payingSymbols.includes(updatedReels[pos[0]][1])) {
                                toResizeXway = true;
                                roundEndHeights[pos[0]][1] = 100;
                            }

                            if (toResizeXway) {

                                roundEndHeights[pos[0]][pos[1]] = 300;
                            } else {
                                roundEndHeights[pos[0]][pos[1]] = 200;
                            }
                        }
                    }
                } else {
                    roundEndHeights[pos[0]][pos[1]] = 200;
                }
            } else if (XwaysHoarder2.model.xwaysCountPerReel[pos[0]] >= 2) { // check for xways merger
                let isXwaysResize = false;
                if (!updatedReels[pos[0]].includes("SC") && !updatedReels[pos[0]].includes("SSC") && !updatedReels[pos[0]].includes("XS") && !updatedReels[pos[0]].includes("XN")) {
                    if (XwaysHoarder2.model.xwaysCountPerReel[pos[0]] === 2) {
                        if (pos[1] === 0 && updatedReels[pos[0]][1] === "XW") {
                            if (XwaysHoarder2Statics.payingSymbols.includes(updatedReels[pos[0]][2])) {
                                roundEndHeights[pos[0]][2] = 100;
                                isXwaysResize = true;
                            }
                            roundEndHeights[pos[0]][1] = 0;

                        } else if (pos[1] === 1 && updatedReels[pos[0]][2] === "XW") {
                            if (XwaysHoarder2Statics.payingSymbols.includes(updatedReels[pos[0]][0])) {
                                roundEndHeights[pos[0]][0] = 100;
                                isXwaysResize = true;
                            }
                            roundEndHeights[pos[0]][2] = 0;

                        }

                        if (isXwaysResize) {
                            roundEndHeights[pos[0]][pos[1]] = 500;
                        } else {
                            roundEndHeights[pos[0]][pos[1]] = 400;

                        }

                    } else if (XwaysHoarder2.model.xwaysCountPerReel[pos[0]] === 3) {
                        roundEndHeights[pos[0]][2] = 0;
                        roundEndHeights[pos[0]][1] = 0;
                        roundEndHeights[pos[0]][0] = 600;

                    }
                } else {
                    if (XwaysHoarder2.model.xwaysCountPerReel[pos[0]] === 2) {
                        if (pos[1] === 0) {
                            if (updatedReels[pos[0]][2] === "XW" && updatedReels[pos[0]][1] !== "XW") {   //case 1 [xw,sc,xw]
                                roundEndHeights[pos[0]][0] = 200;

                                roundEndHeights[pos[0]][2] = 200;

                            } else if (updatedReels[pos[0]][1] === "XW") { //merger case

                                roundEndHeights[pos[0]][1] = 0;
                                roundEndHeights[pos[0]][0] = 400;

                            }
                        } else if (pos[1] === 1 && updatedReels[pos[0]][2] === "XW") {//merger case
                            roundEndHeights[pos[0]][2] = 0;
                            roundEndHeights[pos[0]][1] = 400;

                        }
                    }
                }
            }
        });
        return roundEndHeights;
    }


    public static scalingdirectionCalculator(): string[][] {
        const directionNames: string[][] = [];
        if (XwaysHoarder2.model.endSpinHeights.length > 0) {
            XwaysHoarder2.model.endSpinHeights.forEach((symHeightArray: number[], reelNo: number) => {
                let reelSymDirection: string[] = [];
                if (symHeightArray[0] === 100 && symHeightArray[1] === 100 && symHeightArray[2] === 400) {
                    reelSymDirection = ["north", "north", "north"];
                } else if (symHeightArray[0] === 400 && symHeightArray[1] === 100 && symHeightArray[2] === 100) {
                    reelSymDirection = ["south", "south", "south"];
                } else if (symHeightArray[0] === 100 && symHeightArray[1] === 400 && symHeightArray[2] === 100) {
                    reelSymDirection = ["north", "centre", "south"];
                } else if (symHeightArray[0] === 500 && symHeightArray[1] === 0 && symHeightArray[2] === 100) {
                    reelSymDirection = ["south", "none", "south"];
                } else if (symHeightArray[0] === 100 && symHeightArray[1] === 500 && symHeightArray[2] === 0) {
                    reelSymDirection = ["north", "north", "none"];
                } else {
                    reelSymDirection = ["none", "none", "none"];
                }
                directionNames.push(reelSymDirection);
            });


        }


        return directionNames;
    }
}